import { render, staticRenderFns } from "./Create-Lead.vue?vue&type=template&id=3fcf8c8d&scoped=true"
import script from "./Create-Lead.vue?vue&type=script&lang=js"
export * from "./Create-Lead.vue?vue&type=script&lang=js"
import style0 from "./Create-Lead.vue?vue&type=style&index=0&id=3fcf8c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcf8c8d",
  null
  
)

export default component.exports